// This file is auto-generated. Do not edit manually.
// Generated 2026-09-04T20:47:59.848Z
// Total media: 381 (Images: 371, Videos: 10)

// ============================================
// MEDIA IMPORTS
// ============================================

import accenture from '../images/accenture.png';
import afterappleeventslistDM from '../images/after-apple-events-list-D-M.png';
import afterssdashboard from '../images/after-ss-dashboard.png';
import aftersumcompanypeopledesktop from '../images/after-sum-company-people-desktop.png';
import aftersummanageproject from '../images/after-sum-manage-project.png';
import agtdomainsthumbnail from '../images/agt-domains-thumbnail.jpg';
import agtregistrydiscovery from '../images/agt-registry-discovery.jpg';
import agtregistrythumbnail from '../images/agt-registry-thumbnail.jpg';
import aicollabdesktopscreenshot from '../images/ai-collab-desktop-screenshot.png';
import aicollabrevisingapproachforflexibility from '../images/ai-collab-revising-approach-for-flexibility.jpg';
import aicollabsystemcontent from '../images/ai-collab-system-content.jpg';
import aicollabsystemimages from '../images/ai-collab-system-images.jpg';
import aicollabsystemjson from '../images/ai-collab-system-json.jpg';
import aicollabsystem from '../images/ai-collab-system.jpg';
import aicollabthumbnail from '../images/ai-collab-thumbnail.jpg';
import aicollabtroubleshootingrichtext from '../images/ai-collab-troubleshooting-rich-text.jpg';
import aidebugbrowserconsole from '../images/ai-debug-browser-console.jpg';
import aidebugcontentrenderingandimagemappingbad from '../images/ai-debug-content-rendering-and-image-mapping-bad.jpg';
import aidebugcontentrenderingandimagemapping from '../images/ai-debug-content-rendering-and-image-mapping.jpg';
import aidebugsolvedcontentrenderingbutusagelimitreached from '../images/ai-debug-solved-content-rendering-but-usage-limit-reached.jpg';
import aidebugtimelimit from '../images/ai-debug-time-limit.jpg';
import aidebugtimelimit1 from '../images/ai-debug-time-limit.png';
import aidebugusagelimit from '../images/ai-debug-usage-limit.jpg';
import aideliverytrackerdeliverydetails from '../images/ai-delivery-tracker-delivery-details.jpg';
import aideliverytrackergrid from '../images/ai-delivery-tracker-grid.jpg';
import aideliverytrackerhistory from '../images/ai-delivery-tracker-history.jpg';
import aideliverytrackerthumbnail from '../images/ai-delivery-tracker-thumbnail.jpg';
import appleaddeventtoseries1 from '../images/apple-add-event-to-series-1.png';
import appleaddeventtoseries2 from '../images/apple-add-event-to-series-2.png';
import appleeventoverview from '../images/apple-event-overview.jpg';
import appleeventslistbridgedesktop from '../images/apple-events-list-bridge-desktop.jpeg';
import appleeventslistbridgemobile from '../images/apple-events-list-bridge-mobile.jpeg';
import appleeventslistorigindesktop from '../images/apple-events-list-origin-desktop.jpeg';
import appleeventslistoriginmobile from '../images/apple-events-list-origin-mobile.jpg';
import appleeventslist from '../images/apple-events-list.jpg';
import appleheuristicrecommendations from '../images/apple-heuristic-recommendations.jpg';
import applemockupaddeventtoseriessdigfnbweg from '../images/apple-mockup-add-event-to-series-sdigfnbweg.png';
import appleoverviewdsdesktop from '../images/apple-overview-ds-desktop.jpg';
import appleoverviewdsmobile from '../images/apple-overview-ds-mobile.jpg';
import appleovervieworigindesktop from '../images/apple-overview-origin-desktop.jpg';
import appleovervieworiginmobile from '../images/apple-overview-origin-mobile.jpg';
import applesingleviewneweventcreation from '../images/apple-single-view-new-event-creation.png';
import applesketchaiideation1 from '../images/apple-sketch-ai-ideation-1.jpg';
import applesketchaiideation2 from '../images/apple-sketch-ai-ideation-2.jpg';
import applesketchcommunicationsscopeideation from '../images/apple-sketch-communications-scope-ideation.jpg';
import applesketchnewfromtemplate from '../images/apple-sketch-new-from-template.jpg';
import applesketchpersonas from '../images/apple-sketch-personas.jpg';
import applesketchredesignapproachesideation from '../images/apple-sketch-redesign-approaches-ideation.jpg';
import applesketchtemplatedefinition from '../images/apple-sketch-template-definition.jpg';
import applethumbnail from '../images/apple-thumbnail.jpg';
import applethumbnail1 from '../images/apple-thumbnail.png';
import appleumdsdesktop from '../images/apple-um-ds-desktop.jpg';
import appleumdsmobile from '../images/apple-um-ds-mobile.jpg';
import appleumorigindesktop from '../images/apple-um-origin-desktop.jpg';
import appleumoriginmobile from '../images/apple-um-origin-mobile.jpeg';
import apple from '../images/apple.png';
import automatedemailtestscript from '../images/automated-email-test-script.png';
import beforeappleeventslistDM from '../images/before-apple-events-list-D-M.png';
import beforessdashboard from '../images/before-ss-dashboard.png';
import beforesumcompanypeopledesktop from '../images/before-sum-company-people-desktop.png';
import beforesummanageproject from '../images/before-sum-manage-project.png';
import buildprocessconvertcontent1 from '../images/build-process-convert-content-1.jpg';
import buildprocessconvertcontent2 from '../images/build-process-convert-content-2.jpg';
import buildprocessrunbuild from '../images/build-process-run-build.jpg';
import bulkactions from '../images/bulk-actions.png';
import case1cardthumbnail from '../images/case1-card-thumbnail.svg';
import case1fig1verificationtiers from '../images/case1-fig1-verification-tiers.svg';
import case1fig2monkeypatchtwograders from '../images/case1-fig2-monkeypatch-two-graders.svg';
import case1fig3doctrineladder from '../images/case1-fig3-doctrine-ladder.svg';
import case1fig4judgesuitegrowth from '../images/case1-fig4-judge-suite-growth.svg';
import case2cardthumbnail from '../images/case2-card-thumbnail.svg';
import case2fig1probelifecycle from '../images/case2-fig1-probe-lifecycle.svg';
import case2fig2catchestochecks from '../images/case2-fig2-catches-to-checks.svg';
import case2fig3d021d022supersession from '../images/case2-fig3-d021-d022-supersession.svg';
import case2fig4ledgerentryanatomy from '../images/case2-fig4-ledger-entry-anatomy.svg';
import case2probeagents from '../images/case2-probe-agents.png';
import case3cardthumbnail from '../images/case3-card-thumbnail.svg';
import case3fig1fivegenerations from '../images/case3-fig1-five-generations.svg';
import case3fig2fanoutrestructured from '../images/case3-fig2-fanout-restructured.svg';
import case3fig3catalogtrajectory from '../images/case3-fig3-catalog-trajectory.svg';
import case3fig4minedbacklogcomposition from '../images/case3-fig4-mined-backlog-composition.svg';
import case3studdogfoodprocess from '../images/case3-stud-dogfood-process.png';
import case3acardthumbnail from '../images/case3a-card-thumbnail.svg';
import case3afig1systemfivestages from '../images/case3a-fig1-system-five-stages.svg';
import case3afig2onepasstwooutputs from '../images/case3a-fig2-one-pass-two-outputs.svg';
import case3afig3independentderivation from '../images/case3a-fig3-independent-derivation.svg';
import case3afig4wheredefectswerecaught from '../images/case3a-fig4-where-defects-were-caught.svg';
import case3afig5settleabilitybysourcetype from '../images/case3a-fig5-settleability-by-source-type.svg';
import case3ashot6objectiveintaketable from '../images/case3a-shot6-objective-intake-table.png';
import case3ashot7shippingpath from '../images/case3a-shot7-shipping-path.png';
import case4cardthumbnail from '../images/case4-card-thumbnail.svg';
import case4fig1sixlayercontextstack from '../images/case4-fig1-six-layer-context-stack.svg';
import case4fig2conventiontomechanism from '../images/case4-fig2-convention-to-mechanism.svg';
import case4fig3backstopproof from '../images/case4-fig3-backstop-proof.svg';
import case4fig4retropromotionpath from '../images/case4-fig4-retro-promotion-path.svg';
import case4fig5originexchange from '../images/case4-fig5-origin-exchange.svg';
import case5cardthumbnail from '../images/case5-card-thumbnail.svg';
import case5fig1chainofdefense from '../images/case5-fig1-chain-of-defense.svg';
import case5fig2credentialtopology from '../images/case5-fig2-credential-topology.svg';
import case5fig3incident273timeline from '../images/case5-fig3-incident-273-timeline.svg';
import case5fig4deployordering from '../images/case5-fig4-deploy-ordering.svg';
import case6cardthumbnail from '../images/case6-card-thumbnail.svg';
import case6fig1decisionstomechanisms from '../images/case6-fig1-decisions-to-mechanisms.svg';
import case6fig2onerulefourlayers from '../images/case6-fig2-one-rule-four-layers.svg';
import case6fig3codemodvolumeandjudgment from '../images/case6-fig3-codemod-volume-and-judgment.svg';
import case6fig4gateordercheapchecksfirst from '../images/case6-fig4-gate-order-cheap-checks-first.svg';
import case6studcom from '../images/case6-stud.com.png';
import case7cardthumbnail from '../images/case7-card-thumbnail.svg';
import case7fig1orchestrationselfsimilarity from '../images/case7-fig1-orchestration-self-similarity.svg';
import case7fig2roletiersmeasured from '../images/case7-fig2-role-tiers-measured.svg';
import case7fig3incidenttorule from '../images/case7-fig3-incident-to-rule.svg';
import case7fig4attentionrouter from '../images/case7-fig4-attention-router.svg';
import case7probeagents from '../images/case7-probe-agents.png';
import case7studdogfoodprocess from '../images/case7-stud-dogfood-process.png';
import collaborationflow from '../images/collaboration-flow.jpg';
import daneldorado from '../images/dan-eldorado.jpg';
import deepoutboundleadstrategies from '../images/deep-outbound-lead-strategies.png';
import deepoutboundthumbnail from '../images/deep-outbound-thumbnail.png';
import ekf5una5i2trablu from '../images/ekf5una5i2trablu.png';
import errorsaudit from '../images/errors-audit.png';
import errorsexample from '../images/errors-example.png';
import eventecosystemplaceholder from '../images/event-ecosystem-placeholder.png';
import eventslistafter from '../images/events-list-after.png';
import eventslistbefore from '../images/events-list-before.png';
import exelonthumbnail from '../images/exelon-thumbnail.jpg';
import exelon from '../images/exelon.png';
import focusgroups from '../images/focus-groups.png';
import foresightcardthumbnail from '../images/foresight-card-thumbnail.svg';
import foresightfig1stylesbymodes from '../images/foresight-fig1-styles-by-modes.svg';
import foresightfig2intakemenus from '../images/foresight-fig2-intake-menus.svg';
import foresightfig3synthesispipeline from '../images/foresight-fig3-synthesis-pipeline.svg';
import gitfigafterpull from '../images/gitfig-after-pull.png';
import gitfigauthdevicecode from '../images/gitfig-auth-device-code.png';
import gitfigauthsignin from '../images/gitfig-auth-signin.png';
import gitfigbeforepull from '../images/gitfig-before-pull.png';
import gitfigbranchcreated from '../images/gitfig-branch-created.png';
import gitfigchangenotification from '../images/gitfig-change-notification.png';
import gitfigchangelog from '../images/gitfig-changelog.png';
import gitfigcommunitybugreportandresponse from '../images/gitfig-community-bug-report-and-response.png';
import gitfigcreatebranch from '../images/gitfig-create-branch.png';
import gitfigeditvariable from '../images/gitfig-edit-variable.png';
import gitfigfeaturebranchtokens from '../images/gitfig-feature-branch-tokens.png';
import gitfigfigarchitecture from '../images/gitfig-fig-architecture.svg';
import gitfigfilemapping from '../images/gitfig-file-mapping.png';
import gitfiggithubbranches from '../images/gitfig-github-branches.png';
import gitfiglistingbranchpr from '../images/gitfig-listing-branch-pr.png';
import gitfiglistingchanges from '../images/gitfig-listing-changes.png';
import gitfiglistingconnect from '../images/gitfig-listing-connect.png';
import gitfiglistingcontactsheet from '../images/gitfig-listing-contact-sheet.png';
import gitfiglistingcover from '../images/gitfig-listing-cover.png';
import gitfiglistingmapping from '../images/gitfig-listing-mapping.png';
import gitfiglistingmodes from '../images/gitfig-listing-modes.png';
import gitfiglistingpullundo from '../images/gitfig-listing-pull-undo.png';
import gitfigmainpanel from '../images/gitfig-main-panel.png';
import gitfigmakebridge from '../images/gitfig-make-bridge.png';
import gitfigpostoriginal from '../images/gitfig-post-original.png';
import gitfigprcreated from '../images/gitfig-pr-created.png';
import gitfigprform from '../images/gitfig-pr-form.png';
import gitfigpullsuccess from '../images/gitfig-pull-success.png';
import gitfigtestimonialerik from '../images/gitfig-testimonial-erik.png';
import gitfigtestimonialmarco from '../images/gitfig-testimonial-marco.png';
import gitfigthumbnail from '../images/gitfig-thumbnail.gif';
import gitfigthumbnail1 from '../images/gitfig-thumbnail.png';
import gitfigtraction250emailsubscribers from '../images/gitfig-traction-250-email-subscribers.png';
import gitfigtraction85installs from '../images/gitfig-traction-85-installs.png';
import gitfigtractionfirstthreeweeks from '../images/gitfig-traction-first-three-weeks.png';
import githubcontributions from '../images/github-contributions.png';
import gryptothumbnail from '../images/grypto-thumbnail.jpg';
import headshot from '../images/headshot.png';
import heuristicsevaluationform from '../images/heuristics-evaluation-form.png';
import historicalanalysis from '../images/historical-analysis.png';
import identifiedsolutionaftermessagelimitthensuggestedfix from '../images/identified-solution-after-message-limit-then-suggested-fix.png';
import insightsbrainstorm from '../images/insights-brainstorm.jpg';
import insightsequipmentv5 from '../images/insights-equipment-v5.jpg';
import keywords from '../images/keywords.png';
import llmanalysisdashboardexecutivesummary from '../images/llm-analysis-dashboard_executive-summary.png';
import llmanalysisdashboardnextsteps from '../images/llm-analysis-dashboard_next-steps.png';
import llmanalysisdashboardoverview from '../images/llm-analysis-dashboard_overview.png';
import llmanalysisdashboardpatternanalysis1 from '../images/llm-analysis-dashboard_pattern-analysis-1.png';
import llmanalysisdashboardpatternanalysis2 from '../images/llm-analysis-dashboard_pattern-analysis-2.png';
import llmanalysisdashboardpatternanalysis from '../images/llm-analysis-dashboard_pattern-analysis.png';
import llmanalysisdashboardpromptoptimizer from '../images/llm-analysis-dashboard_prompt-optimizer.png';
import llmanalysisdashboardrecommendations from '../images/llm-analysis-dashboard_recommendations.png';
import llmbrainstorm2 from '../images/llm-brainstorm-2.jpg';
import llmbrainstorm3 from '../images/llm-brainstorm-3.jpg';
import llmbrainstorm4 from '../images/llm-brainstorm-4.jpg';
import llmbrainstorm from '../images/llm-brainstorm.jpg';
import llmchatdemoposter from '../images/llm-chat-demo-poster.png';
import llmchatdemo from '../images/llm-chat-demo.mp4'; // VIDEO
import llmchathoverplay from '../images/llm-chat-hover-play.mp4'; // VIDEO
import llmchatinputarea from '../images/llm-chat-input-area.mp4'; // VIDEO
import llmchatnewchat from '../images/llm-chat-new-chat.mp4'; // VIDEO
import llmchatpromptpresets from '../images/llm-chat-prompt-presets.mp4'; // VIDEO
import llmchatreplyanimationenter from '../images/llm-chat-reply-animation-enter.mp4'; // VIDEO
import llmchatsendreply from '../images/llm-chat-send-reply.mp4'; // VIDEO
import llmchattheatermode from '../images/llm-chat-theater-mode.mp4'; // VIDEO
import llmchatthinking from '../images/llm-chat-thinking.mp4'; // VIDEO
import llmchatthumbnail from '../images/llm-chat-thumbnail.png';
import llmfigmamake from '../images/llm-figma-make.png';
import llmguianalysispromptclaude from '../images/llm-gui-analysis-prompt-claude.png';
import llmguianalysispromptgemini from '../images/llm-gui-analysis-prompt-gemini.png';
import llmpopulatedchat from '../images/llm-populated-chat.jpg';
import llmsketchfigmamake from '../images/llm-sketch-figma-make.jpg';
import llmwhiteboard from '../images/llm-whiteboard.jpg';
import magicleapthumbnail from '../images/magic-leap-thumbnail.gif';
import magicleap from '../images/magic-leap.png';
import mcpregisteragent from '../images/mcp-register-agent.png';
import messagelimit from '../images/message-limit.png';
import modelevalanalysisempty from '../images/model-eval-analysis-empty.png';
import modelevalinterfacelabels from '../images/model-eval-interface-labels.png';
import modelevaljsonexport from '../images/model-eval-json-export.png';
import modelevaljsonsubmission from '../images/model-eval-json-submission.png';
import modelevalthumbnail from '../images/model-eval-thumbnail.png';
import modeloutputevalinterface from '../images/model-output-eval-interface.png';
import obiancardthumbnail from '../images/obian-card-thumbnail.svg';
import obianfig1fourlayerrouter from '../images/obian-fig1-four-layer-router.svg';
import obianfig2postmortemarc from '../images/obian-fig2-postmortem-arc.svg';
import obianfig3feedbackloop from '../images/obian-fig3-feedback-loop.svg';
import obiantriniresolved from '../images/obian-trini-resolved.png';
import outboundanalytics from '../images/outbound-analytics.png';
import outboundcampaignstep1 from '../images/outbound-campaign-step1.png';
import outboundcampaignstep2 from '../images/outbound-campaign-step2.png';
import outboundcampaignstep3 from '../images/outbound-campaign-step3.png';
import outboundcampaignstep4 from '../images/outbound-campaign-step4.png';
import outbounddashboard from '../images/outbound-dashboard.png';
import outbounddomains from '../images/outbound-domains.png';
import outboundescalations from '../images/outbound-escalations.png';
import outboundleads from '../images/outbound-leads.png';
import outboundphase3 from '../images/outbound-phase-3.png';
import outboundphase4 from '../images/outbound-phase-4.png';
import outboundphase5 from '../images/outbound-phase-5.png';
import outboundplan from '../images/outbound-plan.png';
import outboundsettings from '../images/outbound-settings.png';
import outboundtemplates from '../images/outbound-templates.png';
import outboundthumbnail from '../images/outbound-thumbnail.jpg';
import petalaitrainingsession from '../images/petal-ai-training-session.png';
import petalalphaappscombined from '../images/petal-alpha-apps-combined.png';
import petalapidocsoscnode from '../images/petal-api-docs-osc-node.png';
import petalapidocs from '../images/petal-api-docs.png';
import petalbrowclickthumbnail from '../images/petal-brow-click-thumbnail.gif';
import petaldatalogspc from '../images/petal-data-logs-pc.png';
import petaldesignsystembuttons from '../images/petal-design-system-buttons.png';
import petaldesignsystemcolor from '../images/petal-design-system-color.png';
import petaldesignsystemfab from '../images/petal-design-system-fab.png';
import petaldesignsystemtypography from '../images/petal-design-system-typography.png';
import petaldesignsystem from '../images/petal-design-system.png';
import petalfirstcustomersupport from '../images/petal-first-customer-support.png';
import petalkeymapper from '../images/petal-keymapper.png';
import petalmarkersalphainput from '../images/petal-markers-alpha-input.png';
import petalmarkersalphaoutput from '../images/petal-markers-alpha-output.png';
import petalmetrics010 from '../images/petal-metrics-0.1.0.png';
import petalmetrics030 from '../images/petal-metrics-0.3.0.png';
import petalmetrics053stream from '../images/petal-metrics-0.5.3-stream.gif';
import petalmetrics053streaming from '../images/petal-metrics-0.5.3-streaming.png';
import petalmetrics081 from '../images/petal-metrics-0.8.1.png';
import petalmetrics100buttonstates from '../images/petal-metrics-1.0.0-button-states.png';
import petalmetrics100inspirationanalysis2 from '../images/petal-metrics-1.0.0-inspiration-analysis-2.png';
import petalmetrics100inspirationanalysis from '../images/petal-metrics-1.0.0-inspiration-analysis.png';
import petalmetrics100panes from '../images/petal-metrics-1.0.0-panes.png';
import petalmetrics100wireframe from '../images/petal-metrics-1.0.0-wireframe.png';
import petalmetrics100 from '../images/petal-metrics-1.0.0.png';
import petalmetricscomponentsandbox from '../images/petal-metrics-component-sandbox.png';
import petalmetricsdownloaddashboard from '../images/petal-metrics-download-dashboard.png';
import petalmetricsinteractiveprototype from '../images/petal-metrics-interactive-prototype.mp4'; // VIDEO
import petalmetricsthumbnail from '../images/petal-metrics-thumbnail.gif';
import petalmetricsthumbnail1 from '../images/petal-metrics-thumbnail.jpg';
import petalsamsungposter from '../images/petal-samsung-poster.png';
import petalsciencemuseum from '../images/petal-science-museum.png';
import petaltradebooth from '../images/petal-trade-booth.png';
import petalunitydebugpanel from '../images/petal-unity-debug-panel.png';
import petaluxresearchclicks from '../images/petal-ux-research-clicks.png';
import petalvizmvp from '../images/petal-viz-mvp.png';
import petalvropenbci from '../images/petal-vr-openbci.png';
import petalvr from '../images/petal-vr.png';
import petalwireframe from '../images/petal-wireframe.png';
import petal from '../images/petal.png';
import pfcmsworkflowspreadsheeteditor from '../images/pf-cms-workflow-spreadsheet-editor.jpg';
import picksiadmin from '../images/pick-si-admin.jpg';
import picksithumbnail from '../images/pick-si-thumbnail.jpg';
import pincerpaythumbnail from '../images/pincerpay-thumbnail.png';
import placeholder from '../images/placeholder.jpg';
import playtalkdownaudioclip from '../images/play-talkdown-audio-clip.jpg';
import pmcombined from '../images/pm-combined.png';
import pmdashboard from '../images/pm-dashboard.png';
import pmmanagement from '../images/pm-management.png';
import pmneed from '../images/pm-need.png';
import pmusability from '../images/pm-usability.png';
import probecardthumbnail from '../images/probe-card-thumbnail.svg';
import probefig1fanout from '../images/probe-fig1-fanout.svg';
import probefig2promptsliveonce from '../images/probe-fig2-prompts-live-once.svg';
import probefig3whateachlenscaught from '../images/probe-fig3-what-each-lens-caught.svg';
import repostructure10242024 from '../images/repo-structure-10-24-2024.jpg';
import repostructurebrief10242024 from '../images/repo-structure-brief-10-24-2024.jpg';
import samsclub from '../images/sams-club.png';
import scsearchpaneannotated from '../images/sc-search-pane-annotated.png';
import scorecalculation from '../images/score-calculation.png';
import screencapturewebmailporkbun20250405020234 from '../images/screencapture-webmail-porkbun-2025-04-05-02_02_34.png';
import screencapturewebmailporkbun20250405020256 from '../images/screencapture-webmail-porkbun-2025-04-05-02_02_56.png';
import scsinterviewsynthesis from '../images/scs-interview-synthesis.jpg';
import securitydashboardthumbnail from '../images/security-dashboard-thumbnail.jpg';
import senseradesignsystembuttons from '../images/sensera-design-system-buttons.jpg';
import senseradesignsystemcolors from '../images/sensera-design-system-colors.jpg';
import senseradesignsystemtypography from '../images/sensera-design-system-typography.jpg';
import senseratalkdownthumbnail from '../images/sensera-talkdown-thumbnail.jpg';
import signalscardthumbnail from '../images/signals-card-thumbnail.svg';
import signalsdashboardoverview from '../images/signals-dashboard-overview.png';
import signalsfigdetectionpasses from '../images/signals-fig-detection-passes.svg';
import signalsinsightcards from '../images/signals-insight-cards.png';
import signalsnetworkgraph from '../images/signals-network-graph.png';
import signalssteepvblindspot from '../images/signals-steepv-blindspot.png';
import signalstableweldingfilter from '../images/signals-table-welding-filter.png';
import sitedashboardaddcameras from '../images/site-dashboard-add-cameras.jpg';
import sitedashboardthumbnail from '../images/site-dashboard-thumbnail.jpg';
import siteplanmakerexportcanvas from '../images/site-plan-maker-export-canvas.jpg';
import siteplanmakerexportmap from '../images/site-plan-maker-export-map.jpg';
import siteplanmakerorigin from '../images/site-plan-maker-origin.jpg';
import siteplanmakerpdfexport from '../images/site-plan-maker-pdf-export.jpg';
import siteplanmakerscaling from '../images/site-plan-maker-scaling.jpg';
import siteplaneditor from '../images/siteplan-editor.jpg';
import siteplanexport from '../images/siteplan-export.jpg';
import siteplanthumbnail from '../images/siteplan-thumbnail.jpg';
import ssdashboarddemoposter from '../images/ss-dashboard-demo-poster.png';
import ssscsearchannotated from '../images/ss-sc-search-annotated.png';
import stakeholderassumptions from '../images/stakeholder-assumptions.png';
import streamlinedeventcreation from '../images/streamlined-event-creation.png';
import sumeditperson from '../images/sum-edit-person.jpg';
import sumeditprojectdetails from '../images/sum-edit-project-details.jpg';
import sumsketch2 from '../images/sum-sketch-2.jpeg';
import sumsketchrevisions2 from '../images/sum-sketch-revisions-2.jpg';
import sumsketchrevisions from '../images/sum-sketch-revisions.jpg';
import sumsketch from '../images/sum-sketch.jpeg';
import sumuxanalysis from '../images/sum-ux-analysis.jpg';
import SupportingImagePlaceholder from '../images/Supporting Image Placeholder.jpg';
import surveys from '../images/surveys.png';
import synthesiscodes from '../images/synthesis-codes.png';
import synthesislabels from '../images/synthesis-labels.png';
import synthesisthemes from '../images/synthesis-themes.png';
import systemarchitecture from '../images/system-architecture.jpg';
import testimonialjerrylanning from '../images/testimonial-jerry-lanning.jpg';
import testimonialmatthewgiacomazzo from '../images/testimonial-matthew-giacomazzo.jpg';
import testimonialmichaelpeterson from '../images/testimonial-michael-peterson.jpg';
import testimonialmohammedzayed from '../images/testimonial-mohammed-zayed.jpg';
import testimonialshaynasabo from '../images/testimonial-shayna-sabo.jpg';
import testimonialsvetlindenkov from '../images/testimonial-svetlin-denkov.jpg';
import testimonialzachferres from '../images/testimonial-zach-ferres.jpg';
import texttospeechconvertergui from '../images/text-to-speech-converter-gui.png';
import thubbledashboard1 from '../images/thubble-dashboard.jpg';
import thubbledashboard from '../images/thubble-dashboard.png';
import thubbledecisionmatrixawaitingresponses from '../images/thubble-decision-matrix-awaiting-responses.png';
import thubbledecisionmatrixstep1 from '../images/thubble-decision-matrix-step-1.png';
import thubbledecisionmatrixstep2 from '../images/thubble-decision-matrix-step-2.png';
import thubbledecisionmatrixstep3 from '../images/thubble-decision-matrix-step-3.png';
import thubbledecisionmatrixstep4 from '../images/thubble-decision-matrix-step-4.png';
import thubblefirstproddeploymenttothubbleai from '../images/thubble-first-prod-deployment-to-thubble-ai.jpg';
import thubblehomepagefuture from '../images/thubble-homepage-future.png';
import thubblehomepage from '../images/thubble-homepage.png';
import ThubbleMVP from '../images/Thubble-MVP.png';
import thubbleprdawaitingresponses from '../images/thubble-prd-awaiting-responses.png';
import thubbleprdcollectingresponses from '../images/thubble-prd-collecting-responses.png';
import thubbleprdgeneratedoutput from '../images/thubble-prd-generated-output.png';
import thubbleprdstep1empty from '../images/thubble-prd-step-1-empty.png';
import thubbleprdstep1filled from '../images/thubble-prd-step-1-filled.png';
import thubbleprdstep2 from '../images/thubble-prd-step-2.png';
import thubbleprdstep3 from '../images/thubble-prd-step-3.png';
import thubbleprdstep4empty from '../images/thubble-prd-step-4-empty.png';
import thubbleprdstep4filled from '../images/thubble-prd-step-4-filled.png';
import thubbleresponseformempty from '../images/thubble-response-form-empty.png';
import thubbleresponseformfilled from '../images/thubble-response-form-filled.png';
import thubbleselectworkflow from '../images/thubble-select-workflow.png';
import thubblethumbnail from '../images/thubble-thumbnail.png';
import thubbleworkflowbuilder from '../images/thubble-workflow-builder.jpg';
import thubbleworkflowlist from '../images/thubble-workflow-list.png';
import ttsgui from '../images/tts-gui.png';
import usabilityheuristicevaluationpresentationpage5 from '../images/usability-heuristic-evaluation-presentation_page_5.jpg';
import usabilityheuristicsresults from '../images/usability-heuristics-results.png';
import utexas from '../images/utexas.png';
import uxresearchneeds from '../images/ux-research-needs.png';
import wendysthumbnail from '../images/wendys-thumbnail.jpg';
import wendys from '../images/wendys.png';
import workshopfacilitation1 from '../images/workshop-facilitation-1-.png';
import workshops from '../images/workshops.png';

// ============================================
// MEDIA MAP
// ============================================

export const imageMap = {
  '/images/accenture.png': accenture,
  '/images/after-apple-events-list-D-M.png': afterappleeventslistDM,
  '/images/after-ss-dashboard.png': afterssdashboard,
  '/images/after-sum-company-people-desktop.png': aftersumcompanypeopledesktop,
  '/images/after-sum-manage-project.png': aftersummanageproject,
  '/images/agt-domains-thumbnail.jpg': agtdomainsthumbnail,
  '/images/agt-registry-discovery.jpg': agtregistrydiscovery,
  '/images/agt-registry-thumbnail.jpg': agtregistrythumbnail,
  '/images/ai-collab-desktop-screenshot.png': aicollabdesktopscreenshot,
  '/images/ai-collab-revising-approach-for-flexibility.jpg': aicollabrevisingapproachforflexibility,
  '/images/ai-collab-system-content.jpg': aicollabsystemcontent,
  '/images/ai-collab-system-images.jpg': aicollabsystemimages,
  '/images/ai-collab-system-json.jpg': aicollabsystemjson,
  '/images/ai-collab-system.jpg': aicollabsystem,
  '/images/ai-collab-thumbnail.jpg': aicollabthumbnail,
  '/images/ai-collab-troubleshooting-rich-text.jpg': aicollabtroubleshootingrichtext,
  '/images/ai-debug-browser-console.jpg': aidebugbrowserconsole,
  '/images/ai-debug-content-rendering-and-image-mapping-bad.jpg': aidebugcontentrenderingandimagemappingbad,
  '/images/ai-debug-content-rendering-and-image-mapping.jpg': aidebugcontentrenderingandimagemapping,
  '/images/ai-debug-solved-content-rendering-but-usage-limit-reached.jpg': aidebugsolvedcontentrenderingbutusagelimitreached,
  '/images/ai-debug-time-limit.jpg': aidebugtimelimit,
  '/images/ai-debug-time-limit.png': aidebugtimelimit1,
  '/images/ai-debug-usage-limit.jpg': aidebugusagelimit,
  '/images/ai-delivery-tracker-delivery-details.jpg': aideliverytrackerdeliverydetails,
  '/images/ai-delivery-tracker-grid.jpg': aideliverytrackergrid,
  '/images/ai-delivery-tracker-history.jpg': aideliverytrackerhistory,
  '/images/ai-delivery-tracker-thumbnail.jpg': aideliverytrackerthumbnail,
  '/images/apple-add-event-to-series-1.png': appleaddeventtoseries1,
  '/images/apple-add-event-to-series-2.png': appleaddeventtoseries2,
  '/images/apple-event-overview.jpg': appleeventoverview,
  '/images/apple-events-list-bridge-desktop.jpeg': appleeventslistbridgedesktop,
  '/images/apple-events-list-bridge-mobile.jpeg': appleeventslistbridgemobile,
  '/images/apple-events-list-origin-desktop.jpeg': appleeventslistorigindesktop,
  '/images/apple-events-list-origin-mobile.jpg': appleeventslistoriginmobile,
  '/images/apple-events-list.jpg': appleeventslist,
  '/images/apple-heuristic-recommendations.jpg': appleheuristicrecommendations,
  '/images/apple-mockup-add-event-to-series-sdigfnbweg.png': applemockupaddeventtoseriessdigfnbweg,
  '/images/apple-overview-ds-desktop.jpg': appleoverviewdsdesktop,
  '/images/apple-overview-ds-mobile.jpg': appleoverviewdsmobile,
  '/images/apple-overview-origin-desktop.jpg': appleovervieworigindesktop,
  '/images/apple-overview-origin-mobile.jpg': appleovervieworiginmobile,
  '/images/apple-single-view-new-event-creation.png': applesingleviewneweventcreation,
  '/images/apple-sketch-ai-ideation-1.jpg': applesketchaiideation1,
  '/images/apple-sketch-ai-ideation-2.jpg': applesketchaiideation2,
  '/images/apple-sketch-communications-scope-ideation.jpg': applesketchcommunicationsscopeideation,
  '/images/apple-sketch-new-from-template.jpg': applesketchnewfromtemplate,
  '/images/apple-sketch-personas.jpg': applesketchpersonas,
  '/images/apple-sketch-redesign-approaches-ideation.jpg': applesketchredesignapproachesideation,
  '/images/apple-sketch-template-definition.jpg': applesketchtemplatedefinition,
  '/images/apple-thumbnail.jpg': applethumbnail,
  '/images/apple-thumbnail.png': applethumbnail1,
  '/images/apple-um-ds-desktop.jpg': appleumdsdesktop,
  '/images/apple-um-ds-mobile.jpg': appleumdsmobile,
  '/images/apple-um-origin-desktop.jpg': appleumorigindesktop,
  '/images/apple-um-origin-mobile.jpeg': appleumoriginmobile,
  '/images/apple.png': apple,
  '/images/automated-email-test-script.png': automatedemailtestscript,
  '/images/before-apple-events-list-D-M.png': beforeappleeventslistDM,
  '/images/before-ss-dashboard.png': beforessdashboard,
  '/images/before-sum-company-people-desktop.png': beforesumcompanypeopledesktop,
  '/images/before-sum-manage-project.png': beforesummanageproject,
  '/images/build-process-convert-content-1.jpg': buildprocessconvertcontent1,
  '/images/build-process-convert-content-2.jpg': buildprocessconvertcontent2,
  '/images/build-process-run-build.jpg': buildprocessrunbuild,
  '/images/bulk-actions.png': bulkactions,
  '/images/case1-card-thumbnail.svg': case1cardthumbnail,
  '/images/case1-fig1-verification-tiers.svg': case1fig1verificationtiers,
  '/images/case1-fig2-monkeypatch-two-graders.svg': case1fig2monkeypatchtwograders,
  '/images/case1-fig3-doctrine-ladder.svg': case1fig3doctrineladder,
  '/images/case1-fig4-judge-suite-growth.svg': case1fig4judgesuitegrowth,
  '/images/case2-card-thumbnail.svg': case2cardthumbnail,
  '/images/case2-fig1-probe-lifecycle.svg': case2fig1probelifecycle,
  '/images/case2-fig2-catches-to-checks.svg': case2fig2catchestochecks,
  '/images/case2-fig3-d021-d022-supersession.svg': case2fig3d021d022supersession,
  '/images/case2-fig4-ledger-entry-anatomy.svg': case2fig4ledgerentryanatomy,
  '/images/case2-probe-agents.png': case2probeagents,
  '/images/case3-card-thumbnail.svg': case3cardthumbnail,
  '/images/case3-fig1-five-generations.svg': case3fig1fivegenerations,
  '/images/case3-fig2-fanout-restructured.svg': case3fig2fanoutrestructured,
  '/images/case3-fig3-catalog-trajectory.svg': case3fig3catalogtrajectory,
  '/images/case3-fig4-mined-backlog-composition.svg': case3fig4minedbacklogcomposition,
  '/images/case3-stud-dogfood-process.png': case3studdogfoodprocess,
  '/images/case3a-card-thumbnail.svg': case3acardthumbnail,
  '/images/case3a-fig1-system-five-stages.svg': case3afig1systemfivestages,
  '/images/case3a-fig2-one-pass-two-outputs.svg': case3afig2onepasstwooutputs,
  '/images/case3a-fig3-independent-derivation.svg': case3afig3independentderivation,
  '/images/case3a-fig4-where-defects-were-caught.svg': case3afig4wheredefectswerecaught,
  '/images/case3a-fig5-settleability-by-source-type.svg': case3afig5settleabilitybysourcetype,
  '/images/case3a-shot6-objective-intake-table.png': case3ashot6objectiveintaketable,
  '/images/case3a-shot7-shipping-path.png': case3ashot7shippingpath,
  '/images/case4-card-thumbnail.svg': case4cardthumbnail,
  '/images/case4-fig1-six-layer-context-stack.svg': case4fig1sixlayercontextstack,
  '/images/case4-fig2-convention-to-mechanism.svg': case4fig2conventiontomechanism,
  '/images/case4-fig3-backstop-proof.svg': case4fig3backstopproof,
  '/images/case4-fig4-retro-promotion-path.svg': case4fig4retropromotionpath,
  '/images/case4-fig5-origin-exchange.svg': case4fig5originexchange,
  '/images/case5-card-thumbnail.svg': case5cardthumbnail,
  '/images/case5-fig1-chain-of-defense.svg': case5fig1chainofdefense,
  '/images/case5-fig2-credential-topology.svg': case5fig2credentialtopology,
  '/images/case5-fig3-incident-273-timeline.svg': case5fig3incident273timeline,
  '/images/case5-fig4-deploy-ordering.svg': case5fig4deployordering,
  '/images/case6-card-thumbnail.svg': case6cardthumbnail,
  '/images/case6-fig1-decisions-to-mechanisms.svg': case6fig1decisionstomechanisms,
  '/images/case6-fig2-one-rule-four-layers.svg': case6fig2onerulefourlayers,
  '/images/case6-fig3-codemod-volume-and-judgment.svg': case6fig3codemodvolumeandjudgment,
  '/images/case6-fig4-gate-order-cheap-checks-first.svg': case6fig4gateordercheapchecksfirst,
  '/images/case6-stud.com.png': case6studcom,
  '/images/case7-card-thumbnail.svg': case7cardthumbnail,
  '/images/case7-fig1-orchestration-self-similarity.svg': case7fig1orchestrationselfsimilarity,
  '/images/case7-fig2-role-tiers-measured.svg': case7fig2roletiersmeasured,
  '/images/case7-fig3-incident-to-rule.svg': case7fig3incidenttorule,
  '/images/case7-fig4-attention-router.svg': case7fig4attentionrouter,
  '/images/case7-probe-agents.png': case7probeagents,
  '/images/case7-stud-dogfood-process.png': case7studdogfoodprocess,
  '/images/collaboration-flow.jpg': collaborationflow,
  '/images/dan-eldorado.jpg': daneldorado,
  '/images/deep-outbound-lead-strategies.png': deepoutboundleadstrategies,
  '/images/deep-outbound-thumbnail.png': deepoutboundthumbnail,
  '/images/ekf5una5i2trablu.png': ekf5una5i2trablu,
  '/images/errors-audit.png': errorsaudit,
  '/images/errors-example.png': errorsexample,
  '/images/event-ecosystem-placeholder.png': eventecosystemplaceholder,
  '/images/events-list-after.png': eventslistafter,
  '/images/events-list-before.png': eventslistbefore,
  '/images/exelon-thumbnail.jpg': exelonthumbnail,
  '/images/exelon.png': exelon,
  '/images/focus-groups.png': focusgroups,
  '/images/foresight-card-thumbnail.svg': foresightcardthumbnail,
  '/images/foresight-fig1-styles-by-modes.svg': foresightfig1stylesbymodes,
  '/images/foresight-fig2-intake-menus.svg': foresightfig2intakemenus,
  '/images/foresight-fig3-synthesis-pipeline.svg': foresightfig3synthesispipeline,
  '/images/gitfig-after-pull.png': gitfigafterpull,
  '/images/gitfig-auth-device-code.png': gitfigauthdevicecode,
  '/images/gitfig-auth-signin.png': gitfigauthsignin,
  '/images/gitfig-before-pull.png': gitfigbeforepull,
  '/images/gitfig-branch-created.png': gitfigbranchcreated,
  '/images/gitfig-change-notification.png': gitfigchangenotification,
  '/images/gitfig-changelog.png': gitfigchangelog,
  '/images/gitfig-community-bug-report-and-response.png': gitfigcommunitybugreportandresponse,
  '/images/gitfig-create-branch.png': gitfigcreatebranch,
  '/images/gitfig-edit-variable.png': gitfigeditvariable,
  '/images/gitfig-feature-branch-tokens.png': gitfigfeaturebranchtokens,
  '/images/gitfig-fig-architecture.svg': gitfigfigarchitecture,
  '/images/gitfig-file-mapping.png': gitfigfilemapping,
  '/images/gitfig-github-branches.png': gitfiggithubbranches,
  '/images/gitfig-listing-branch-pr.png': gitfiglistingbranchpr,
  '/images/gitfig-listing-changes.png': gitfiglistingchanges,
  '/images/gitfig-listing-connect.png': gitfiglistingconnect,
  '/images/gitfig-listing-contact-sheet.png': gitfiglistingcontactsheet,
  '/images/gitfig-listing-cover.png': gitfiglistingcover,
  '/images/gitfig-listing-mapping.png': gitfiglistingmapping,
  '/images/gitfig-listing-modes.png': gitfiglistingmodes,
  '/images/gitfig-listing-pull-undo.png': gitfiglistingpullundo,
  '/images/gitfig-main-panel.png': gitfigmainpanel,
  '/images/gitfig-make-bridge.png': gitfigmakebridge,
  '/images/gitfig-post-original.png': gitfigpostoriginal,
  '/images/gitfig-pr-created.png': gitfigprcreated,
  '/images/gitfig-pr-form.png': gitfigprform,
  '/images/gitfig-pull-success.png': gitfigpullsuccess,
  '/images/gitfig-testimonial-erik.png': gitfigtestimonialerik,
  '/images/gitfig-testimonial-marco.png': gitfigtestimonialmarco,
  '/images/gitfig-thumbnail.gif': gitfigthumbnail,
  '/images/gitfig-thumbnail.png': gitfigthumbnail1,
  '/images/gitfig-traction-250-email-subscribers.png': gitfigtraction250emailsubscribers,
  '/images/gitfig-traction-85-installs.png': gitfigtraction85installs,
  '/images/gitfig-traction-first-three-weeks.png': gitfigtractionfirstthreeweeks,
  '/images/github-contributions.png': githubcontributions,
  '/images/grypto-thumbnail.jpg': gryptothumbnail,
  '/images/headshot.png': headshot,
  '/images/heuristics-evaluation-form.png': heuristicsevaluationform,
  '/images/historical-analysis.png': historicalanalysis,
  '/images/identified-solution-after-message-limit-then-suggested-fix.png': identifiedsolutionaftermessagelimitthensuggestedfix,
  '/images/insights-brainstorm.jpg': insightsbrainstorm,
  '/images/insights-equipment-v5.jpg': insightsequipmentv5,
  '/images/keywords.png': keywords,
  '/images/llm-analysis-dashboard_executive-summary.png': llmanalysisdashboardexecutivesummary,
  '/images/llm-analysis-dashboard_next-steps.png': llmanalysisdashboardnextsteps,
  '/images/llm-analysis-dashboard_overview.png': llmanalysisdashboardoverview,
  '/images/llm-analysis-dashboard_pattern-analysis-1.png': llmanalysisdashboardpatternanalysis1,
  '/images/llm-analysis-dashboard_pattern-analysis-2.png': llmanalysisdashboardpatternanalysis2,
  '/images/llm-analysis-dashboard_pattern-analysis.png': llmanalysisdashboardpatternanalysis,
  '/images/llm-analysis-dashboard_prompt-optimizer.png': llmanalysisdashboardpromptoptimizer,
  '/images/llm-analysis-dashboard_recommendations.png': llmanalysisdashboardrecommendations,
  '/images/llm-brainstorm-2.jpg': llmbrainstorm2,
  '/images/llm-brainstorm-3.jpg': llmbrainstorm3,
  '/images/llm-brainstorm-4.jpg': llmbrainstorm4,
  '/images/llm-brainstorm.jpg': llmbrainstorm,
  '/images/llm-chat-demo-poster.png': llmchatdemoposter,
  '/images/llm-chat-demo.mp4': llmchatdemo, // VIDEO
  '/images/llm-chat-hover-play.mp4': llmchathoverplay, // VIDEO
  '/images/llm-chat-input-area.mp4': llmchatinputarea, // VIDEO
  '/images/llm-chat-new-chat.mp4': llmchatnewchat, // VIDEO
  '/images/llm-chat-prompt-presets.mp4': llmchatpromptpresets, // VIDEO
  '/images/llm-chat-reply-animation-enter.mp4': llmchatreplyanimationenter, // VIDEO
  '/images/llm-chat-send-reply.mp4': llmchatsendreply, // VIDEO
  '/images/llm-chat-theater-mode.mp4': llmchattheatermode, // VIDEO
  '/images/llm-chat-thinking.mp4': llmchatthinking, // VIDEO
  '/images/llm-chat-thumbnail.png': llmchatthumbnail,
  '/images/llm-figma-make.png': llmfigmamake,
  '/images/llm-gui-analysis-prompt-claude.png': llmguianalysispromptclaude,
  '/images/llm-gui-analysis-prompt-gemini.png': llmguianalysispromptgemini,
  '/images/llm-populated-chat.jpg': llmpopulatedchat,
  '/images/llm-sketch-figma-make.jpg': llmsketchfigmamake,
  '/images/llm-whiteboard.jpg': llmwhiteboard,
  '/images/magic-leap-thumbnail.gif': magicleapthumbnail,
  '/images/magic-leap.png': magicleap,
  '/images/mcp-register-agent.png': mcpregisteragent,
  '/images/message-limit.png': messagelimit,
  '/images/model-eval-analysis-empty.png': modelevalanalysisempty,
  '/images/model-eval-interface-labels.png': modelevalinterfacelabels,
  '/images/model-eval-json-export.png': modelevaljsonexport,
  '/images/model-eval-json-submission.png': modelevaljsonsubmission,
  '/images/model-eval-thumbnail.png': modelevalthumbnail,
  '/images/model-output-eval-interface.png': modeloutputevalinterface,
  '/images/obian-card-thumbnail.svg': obiancardthumbnail,
  '/images/obian-fig1-four-layer-router.svg': obianfig1fourlayerrouter,
  '/images/obian-fig2-postmortem-arc.svg': obianfig2postmortemarc,
  '/images/obian-fig3-feedback-loop.svg': obianfig3feedbackloop,
  '/images/obian-trini-resolved.png': obiantriniresolved,
  '/images/outbound-analytics.png': outboundanalytics,
  '/images/outbound-campaign-step1.png': outboundcampaignstep1,
  '/images/outbound-campaign-step2.png': outboundcampaignstep2,
  '/images/outbound-campaign-step3.png': outboundcampaignstep3,
  '/images/outbound-campaign-step4.png': outboundcampaignstep4,
  '/images/outbound-dashboard.png': outbounddashboard,
  '/images/outbound-domains.png': outbounddomains,
  '/images/outbound-escalations.png': outboundescalations,
  '/images/outbound-leads.png': outboundleads,
  '/images/outbound-phase-3.png': outboundphase3,
  '/images/outbound-phase-4.png': outboundphase4,
  '/images/outbound-phase-5.png': outboundphase5,
  '/images/outbound-plan.png': outboundplan,
  '/images/outbound-settings.png': outboundsettings,
  '/images/outbound-templates.png': outboundtemplates,
  '/images/outbound-thumbnail.jpg': outboundthumbnail,
  '/images/petal-ai-training-session.png': petalaitrainingsession,
  '/images/petal-alpha-apps-combined.png': petalalphaappscombined,
  '/images/petal-api-docs-osc-node.png': petalapidocsoscnode,
  '/images/petal-api-docs.png': petalapidocs,
  '/images/petal-brow-click-thumbnail.gif': petalbrowclickthumbnail,
  '/images/petal-data-logs-pc.png': petaldatalogspc,
  '/images/petal-design-system-buttons.png': petaldesignsystembuttons,
  '/images/petal-design-system-color.png': petaldesignsystemcolor,
  '/images/petal-design-system-fab.png': petaldesignsystemfab,
  '/images/petal-design-system-typography.png': petaldesignsystemtypography,
  '/images/petal-design-system.png': petaldesignsystem,
  '/images/petal-first-customer-support.png': petalfirstcustomersupport,
  '/images/petal-keymapper.png': petalkeymapper,
  '/images/petal-markers-alpha-input.png': petalmarkersalphainput,
  '/images/petal-markers-alpha-output.png': petalmarkersalphaoutput,
  '/images/petal-metrics-0.1.0.png': petalmetrics010,
  '/images/petal-metrics-0.3.0.png': petalmetrics030,
  '/images/petal-metrics-0.5.3-stream.gif': petalmetrics053stream,
  '/images/petal-metrics-0.5.3-streaming.png': petalmetrics053streaming,
  '/images/petal-metrics-0.8.1.png': petalmetrics081,
  '/images/petal-metrics-1.0.0-button-states.png': petalmetrics100buttonstates,
  '/images/petal-metrics-1.0.0-inspiration-analysis-2.png': petalmetrics100inspirationanalysis2,
  '/images/petal-metrics-1.0.0-inspiration-analysis.png': petalmetrics100inspirationanalysis,
  '/images/petal-metrics-1.0.0-panes.png': petalmetrics100panes,
  '/images/petal-metrics-1.0.0-wireframe.png': petalmetrics100wireframe,
  '/images/petal-metrics-1.0.0.png': petalmetrics100,
  '/images/petal-metrics-component-sandbox.png': petalmetricscomponentsandbox,
  '/images/petal-metrics-download-dashboard.png': petalmetricsdownloaddashboard,
  '/images/petal-metrics-interactive-prototype.mp4': petalmetricsinteractiveprototype, // VIDEO
  '/images/petal-metrics-thumbnail.gif': petalmetricsthumbnail,
  '/images/petal-metrics-thumbnail.jpg': petalmetricsthumbnail1,
  '/images/petal-samsung-poster.png': petalsamsungposter,
  '/images/petal-science-museum.png': petalsciencemuseum,
  '/images/petal-trade-booth.png': petaltradebooth,
  '/images/petal-unity-debug-panel.png': petalunitydebugpanel,
  '/images/petal-ux-research-clicks.png': petaluxresearchclicks,
  '/images/petal-viz-mvp.png': petalvizmvp,
  '/images/petal-vr-openbci.png': petalvropenbci,
  '/images/petal-vr.png': petalvr,
  '/images/petal-wireframe.png': petalwireframe,
  '/images/petal.png': petal,
  '/images/pf-cms-workflow-spreadsheet-editor.jpg': pfcmsworkflowspreadsheeteditor,
  '/images/pick-si-admin.jpg': picksiadmin,
  '/images/pick-si-thumbnail.jpg': picksithumbnail,
  '/images/pincerpay-thumbnail.png': pincerpaythumbnail,
  '/images/placeholder.jpg': placeholder,
  '/images/play-talkdown-audio-clip.jpg': playtalkdownaudioclip,
  '/images/pm-combined.png': pmcombined,
  '/images/pm-dashboard.png': pmdashboard,
  '/images/pm-management.png': pmmanagement,
  '/images/pm-need.png': pmneed,
  '/images/pm-usability.png': pmusability,
  '/images/probe-card-thumbnail.svg': probecardthumbnail,
  '/images/probe-fig1-fanout.svg': probefig1fanout,
  '/images/probe-fig2-prompts-live-once.svg': probefig2promptsliveonce,
  '/images/probe-fig3-what-each-lens-caught.svg': probefig3whateachlenscaught,
  '/images/repo-structure-10-24-2024.jpg': repostructure10242024,
  '/images/repo-structure-brief-10-24-2024.jpg': repostructurebrief10242024,
  '/images/sams-club.png': samsclub,
  '/images/sc-search-pane-annotated.png': scsearchpaneannotated,
  '/images/score-calculation.png': scorecalculation,
  '/images/screencapture-webmail-porkbun-2025-04-05-02_02_34.png': screencapturewebmailporkbun20250405020234,
  '/images/screencapture-webmail-porkbun-2025-04-05-02_02_56.png': screencapturewebmailporkbun20250405020256,
  '/images/scs-interview-synthesis.jpg': scsinterviewsynthesis,
  '/images/security-dashboard-thumbnail.jpg': securitydashboardthumbnail,
  '/images/sensera-design-system-buttons.jpg': senseradesignsystembuttons,
  '/images/sensera-design-system-colors.jpg': senseradesignsystemcolors,
  '/images/sensera-design-system-typography.jpg': senseradesignsystemtypography,
  '/images/sensera-talkdown-thumbnail.jpg': senseratalkdownthumbnail,
  '/images/signals-card-thumbnail.svg': signalscardthumbnail,
  '/images/signals-dashboard-overview.png': signalsdashboardoverview,
  '/images/signals-fig-detection-passes.svg': signalsfigdetectionpasses,
  '/images/signals-insight-cards.png': signalsinsightcards,
  '/images/signals-network-graph.png': signalsnetworkgraph,
  '/images/signals-steepv-blindspot.png': signalssteepvblindspot,
  '/images/signals-table-welding-filter.png': signalstableweldingfilter,
  '/images/site-dashboard-add-cameras.jpg': sitedashboardaddcameras,
  '/images/site-dashboard-thumbnail.jpg': sitedashboardthumbnail,
  '/images/site-plan-maker-export-canvas.jpg': siteplanmakerexportcanvas,
  '/images/site-plan-maker-export-map.jpg': siteplanmakerexportmap,
  '/images/site-plan-maker-origin.jpg': siteplanmakerorigin,
  '/images/site-plan-maker-pdf-export.jpg': siteplanmakerpdfexport,
  '/images/site-plan-maker-scaling.jpg': siteplanmakerscaling,
  '/images/siteplan-editor.jpg': siteplaneditor,
  '/images/siteplan-export.jpg': siteplanexport,
  '/images/siteplan-thumbnail.jpg': siteplanthumbnail,
  '/images/ss-dashboard-demo-poster.png': ssdashboarddemoposter,
  '/images/ss-sc-search-annotated.png': ssscsearchannotated,
  '/images/stakeholder-assumptions.png': stakeholderassumptions,
  '/images/streamlined-event-creation.png': streamlinedeventcreation,
  '/images/sum-edit-person.jpg': sumeditperson,
  '/images/sum-edit-project-details.jpg': sumeditprojectdetails,
  '/images/sum-sketch-2.jpeg': sumsketch2,
  '/images/sum-sketch-revisions-2.jpg': sumsketchrevisions2,
  '/images/sum-sketch-revisions.jpg': sumsketchrevisions,
  '/images/sum-sketch.jpeg': sumsketch,
  '/images/sum-ux-analysis.jpg': sumuxanalysis,
  '/images/Supporting Image Placeholder.jpg': SupportingImagePlaceholder,
  '/images/surveys.png': surveys,
  '/images/synthesis-codes.png': synthesiscodes,
  '/images/synthesis-labels.png': synthesislabels,
  '/images/synthesis-themes.png': synthesisthemes,
  '/images/system-architecture.jpg': systemarchitecture,
  '/images/testimonial-jerry-lanning.jpg': testimonialjerrylanning,
  '/images/testimonial-matthew-giacomazzo.jpg': testimonialmatthewgiacomazzo,
  '/images/testimonial-michael-peterson.jpg': testimonialmichaelpeterson,
  '/images/testimonial-mohammed-zayed.jpg': testimonialmohammedzayed,
  '/images/testimonial-shayna-sabo.jpg': testimonialshaynasabo,
  '/images/testimonial-svetlin-denkov.jpg': testimonialsvetlindenkov,
  '/images/testimonial-zach-ferres.jpg': testimonialzachferres,
  '/images/text-to-speech-converter-gui.png': texttospeechconvertergui,
  '/images/thubble-dashboard.jpg': thubbledashboard1,
  '/images/thubble-dashboard.png': thubbledashboard,
  '/images/thubble-decision-matrix-awaiting-responses.png': thubbledecisionmatrixawaitingresponses,
  '/images/thubble-decision-matrix-step-1.png': thubbledecisionmatrixstep1,
  '/images/thubble-decision-matrix-step-2.png': thubbledecisionmatrixstep2,
  '/images/thubble-decision-matrix-step-3.png': thubbledecisionmatrixstep3,
  '/images/thubble-decision-matrix-step-4.png': thubbledecisionmatrixstep4,
  '/images/thubble-first-prod-deployment-to-thubble-ai.jpg': thubblefirstproddeploymenttothubbleai,
  '/images/thubble-homepage-future.png': thubblehomepagefuture,
  '/images/thubble-homepage.png': thubblehomepage,
  '/images/Thubble-MVP.png': ThubbleMVP,
  '/images/thubble-prd-awaiting-responses.png': thubbleprdawaitingresponses,
  '/images/thubble-prd-collecting-responses.png': thubbleprdcollectingresponses,
  '/images/thubble-prd-generated-output.png': thubbleprdgeneratedoutput,
  '/images/thubble-prd-step-1-empty.png': thubbleprdstep1empty,
  '/images/thubble-prd-step-1-filled.png': thubbleprdstep1filled,
  '/images/thubble-prd-step-2.png': thubbleprdstep2,
  '/images/thubble-prd-step-3.png': thubbleprdstep3,
  '/images/thubble-prd-step-4-empty.png': thubbleprdstep4empty,
  '/images/thubble-prd-step-4-filled.png': thubbleprdstep4filled,
  '/images/thubble-response-form-empty.png': thubbleresponseformempty,
  '/images/thubble-response-form-filled.png': thubbleresponseformfilled,
  '/images/thubble-select-workflow.png': thubbleselectworkflow,
  '/images/thubble-thumbnail.png': thubblethumbnail,
  '/images/thubble-workflow-builder.jpg': thubbleworkflowbuilder,
  '/images/thubble-workflow-list.png': thubbleworkflowlist,
  '/images/tts-gui.png': ttsgui,
  '/images/usability-heuristic-evaluation-presentation_page_5.jpg': usabilityheuristicevaluationpresentationpage5,
  '/images/usability-heuristics-results.png': usabilityheuristicsresults,
  '/images/utexas.png': utexas,
  '/images/ux-research-needs.png': uxresearchneeds,
  '/images/wendys-thumbnail.jpg': wendysthumbnail,
  '/images/wendys.png': wendys,
  '/images/workshop-facilitation-1-.png': workshopfacilitation1,
  '/images/workshops.png': workshops
};

// Alias for backwards compatibility
export const mediaMap = imageMap;

// Helper to check if a path is a video
export const isVideo = (path) => {
  const videoExtensions = ['.mp4', '.webm', '.mov', '.avi', '.ogg'];
  return videoExtensions.some(ext => path.toLowerCase().endsWith(ext));
};
